import { Button } from '../../Base/Button/Button';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalWithButton,
} from '../../Base/Modal';

import React, { ReactElement } from 'react';
interface Props {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  cancelVariant?: string;
  confirmVariant?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  onToggleExtra?: (e?: React.MouseEvent<HTMLElement>) => void;
  renderButton: ReactElement;
  buttonTooltip?: string;
}

export class ButtonWithConfirmation extends React.PureComponent<Props> {
  public static defaultProps = {
    cancelVariant: 'light',
    confirmVariant: 'primary',
    cancelText: 'Cancel',
    confirmText: 'Confirm',
  };
  public renderDialogContent = (props) => (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggle}
      contentClassName={'border border-danger'}
      size="sm"
    >
      <ModalHeader>
        <span className='rc-font-bold'>{props.title}</span>
      </ModalHeader>
      <ModalBody>
        <p>{this.props.message}</p>
      </ModalBody>
      <ModalFooter className='rc-p-2'>
        <Button
          variant={this.props.cancelVariant}
          className='max-sm:rc-text-xs'
          onClick={(e) => {
            props.toggle(e);
            if (this.props.onCancel) {
              this.props.onCancel();
            }
          }}
        >
          {this.props.cancelText}
        </Button>
        <Button
          variant={this.props.confirmVariant}
          className='max-sm:rc-text-xs'
          onClick={(e) => {
            props.toggle(e);
            if (this.props.onConfirm) {
              this.props.onConfirm();
            }
          }}
        >
          {this.props.confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  );

  public override render() {
    return (
      <ModalWithButton
        buttonComponent={this.props.renderButton}
        buttonTooltip={this.props.buttonTooltip}
        ModalComponent={this.renderDialogContent}
        onToggleExtra={this.props.onToggleExtra}
      />
    );
  }
}
